import React from 'react'
import { Link, LinkProps, useLocation } from 'react-router-dom'
import clsx from 'clsx'

type Props = { underline?: boolean; external?: boolean; to: string } & Omit<LinkProps, 'to'>

function BaseLink({ to, className, underline, children, external, ...others }: Props) {
  const { pathname } = useLocation()

  if (external) {
    return (
      <a
        href={to}
        target='_blank'
        rel='noreferrer'
        className={clsx('hover:!text-[#4E8FC6]', { underline }, className)}
        {...others}
      >
        {children}
      </a>
    )
  }

  return (
    <Link
      to={to}
      className={clsx(
        'font-semibold text-subtitle2 hover:!text-[#4E8FC6]',
        { '!text-[#4E8FC6]': pathname === to, underline },
        className,
      )}
      {...others}
    >
      {children}
    </Link>
  )
}

export default BaseLink
